export default {
  jsonLabel: 'JSON',
  pathLabel: 'Caminho',
  fieldLabel: 'Campo',
  insert: 'Inserir'
}
